// This is used as part of the response to the following requests:
// - /connect/v1/payments
// - /connect/v1/payments/{paymentId}/increment (Auth / Not implemented)
// - /connect/v1/payments/{paymentId}/refunds
// - /connect/v1/payments/{paymentId}/void
const CloverPaymentAndRefundResult = Object.freeze({
    SUCCESS: 'SUCCESS',
    FAIL: 'FAIL',
    INITIATED: 'INITIATED',
    VOIDED: 'VOIDED',
    VOIDING: 'VOIDING',
    VOID_FAILED: 'VOID_FAILED',
    AUTH: 'AUTH',
    AUTH_COMPLETED: 'AUTH_COMPLETED',
    DISCOUNT: 'DISCOUNT',
});

module.exports = CloverPaymentAndRefundResult;
